import { FrequencyValue } from "./FrequencyValue";
import { SpectrumMeter } from "./SpectrumMeter";
export interface HighFreqIntensityRef { intensity: number; triggered: boolean; }
interface HighFreqDebugPanelProps {
  getFrequencyData: () => Float32Array;
  sampleRate: number; fftSize: number; minFreq: number; maxFreq: number;
  onMinFreqChange: (value: number) => void;
  onMaxFreqChange: (value: number) => void;
  intensityRef: React.RefObject<HighFreqIntensityRef>;
}
export function HighFreqDebugPanel(props: HighFreqDebugPanelProps) {
  return <section className="instrument-section frequency-section high-frequency-section" aria-labelledby="high-heading">
    <h2 id="high-heading" className="instrument-heading">高频 / HIGH</h2>
    <div className="frequency-endpoints">
      <FrequencyValue label="高频下限数值" value={props.minFreq / 1000} min={1} max={Math.min(10, props.maxFreq / 1000 - 0.1)}
        step={0.1} decimals={1} unit="kHz" onChange={value => props.onMinFreqChange(Math.round(value * 1000))} />
      <FrequencyValue label="高频上限数值" value={props.maxFreq / 1000} min={Math.max(2, props.minFreq / 1000 + 0.1)} max={20}
        step={0.1} decimals={1} unit="kHz" onChange={value => props.onMaxFreqChange(Math.round(value * 1000))} />
    </div>
    <SpectrumMeter {...props} label="高频" />
    <div className="frequency-range-pair">
      <label htmlFor="high-frequency-min" className="sr-only">高频下限</label>
      <input id="high-frequency-min" type="range" min={1000} max={10000} step={100} value={props.minFreq}
        onChange={event => { const value = event.currentTarget.valueAsNumber;
          if (value < props.maxFreq) props.onMinFreqChange(value); }} />
      <label htmlFor="high-frequency-max" className="sr-only">高频上限</label>
      <input id="high-frequency-max" type="range" min={2000} max={20000} step={100} value={props.maxFreq}
        onChange={event => { const value = event.currentTarget.valueAsNumber;
          if (value > props.minFreq) props.onMaxFreqChange(value); }} />
    </div>
  </section>;
}
